import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7876044b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArticleItem-main" }
const _hoisted_2 = { class: "ArticleItem-main-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "ArticleItem-main-content" }
const _hoisted_5 = { class: "ArticleItem-main-content-title tstn" }
const _hoisted_6 = { class: "ArticleItem-main-content-body tstn" }
const _hoisted_7 = { class: "ArticleItem-msg tstn" }
const _hoisted_8 = { class: "ArticleItem-msg-read" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ArticleItem-msg-read-icon" }, null, -1))
const _hoisted_10 = { class: "ArticleItem-msg-date" }


import { parseInt } from 'lodash'
import { useRtfix, isD2C } from '@/store'
import { useRouter } from 'vue-router'
import { formatViewNum } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // item存在的场景的筛选条件 0.根据文章类型；1.根据文章归档年月；2.根据文章热度；3.全部文章
  type: {
    type: Number,
    default: 3
  }
},
  setup(__props) {

const props = __props
const router = useRouter()



// 跳转文章详情
// const toArticle = (id: string) => {
//   router.push(useRtfix('article', { params: { id, type: props.type } }))
// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(useRtfix)('article', { params: { id: __props.item.frogArticleId, type: props.type } })
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["ArticleItem", _unref(isD2C)() ? 'd2c' : 'b2b'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              referrerPolicy: "no-referrer",
              class: "wrap",
              src: __props.item.frogArticleImgUrl,
              alt: __props.item.frogArticleTitle
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.frogArticleTitle), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.frogArticleSubTitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_unref(formatViewNum)(parseInt(__props.item.viewNum))), 1)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(__props.item.createTime), 1)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})